<header>
  <div class="header-container" [ngClass]="{'cdd-bg': activeModule === 'cdd', 'bq-bg': activeModule === 'bq'}">
    <div class="header-leftSide">
      <div class="toggleMenu">
        <button mat-button color="primary" (click)="toggle()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <div class="logo"><img src="logo.svg" alt="logo" /></div>
      <div class="site-name">
        @switch (activeModule) {
        @case ('sdd') { {{ "supplierDueDiligence" | translate }} }
        @case ('cdd') { {{ "customerDueDiligence" | translate }} }
        @case ('bq') { {{ "businessQuestionnaire" | translate }} }
        @case ('sp') { {{ "sanctionsScreening" | translate }} }
        @case ('ciw') { {{ "complianceInvestigationWorkbench" | translate }} }
        }
      </div>
    </div>
    <div class="header-rightSide">
      <a mat-button (click)="onUserGuideLink()" class="a-link">
        <mat-icon>contact_support</mat-icon>
        {{'userGuide' | translate}}
      </a>

      <button mat-button class="profile-btn" [matMenuTriggerFor]="profileMenu">
        <mat-icon>account_circle</mat-icon>
        <span class="profile-name">{{ userName }}</span>
      </button>

      <mat-menu #profileMenu="matMenu" xPosition="before" class="profile-menu">
        <div class="profile-menu-header" (click)="$event.stopPropagation()">
          <div class="profile-menu-info">
            <div class="profile-menu-name">{{ userName }}</div>
            <div class="profile-menu-email" *ngIf="userEmail">{{ userEmail }}</div>
            <div class="profile-menu-roles">
              <span *ngFor="let role of userRoles" class="role-chip">{{ role }}</span>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="signOut()">
          <mat-icon>logout</mat-icon>
          Sign Out
        </button>
      </mat-menu>
    </div>
  </div>
</header>